function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { guid } from '@okee-uikit/react-utils';
import { Emitter } from '@okee-uikit/react-hooks';
export var OptionState;

(function (OptionState) {
  OptionState[OptionState["SELECTED"] = 2] = "SELECTED";
  OptionState[OptionState["UNSELECTED"] = 0] = "UNSELECTED";
})(OptionState || (OptionState = {}));

export var Option = function (_Emitter) {
  _inherits(Option, _Emitter);

  var _super = _createSuper(Option);

  function Option(select, data, id, optionGroup) {
    var _this;

    _classCallCheck(this, Option);

    _this = _super.call(this);
    _this.optionGroup = null;
    _this.disposed = false;
    _this.id = id || guid();
    _this.select = select;
    _this.optionGroup = optionGroup || null;
    _this.data = data;

    _this.updateOption(data);

    _this.select.registerOption(_assertThisInitialized(_this));

    if (_this.optionGroup) {
      _this.optionGroup.registerOption(_assertThisInitialized(_this));
    }

    return _this;
  }

  _createClass(Option, [{
    key: "updateOption",
    value: function updateOption(data) {
      var oldLabel = this.data.label;
      this.data = _objectSpread(_objectSpread({}, data), {}, {
        disabled: !!data.disabled || this.select.isDisabled(),
        readonly: !!data.readonly || this.select.isReadonly(),
        selected: this.select.isSelected(data.value)
      });

      if (oldLabel !== data.label) {
        this.select.waitForCommit('select-label-update');
      }
    }
  }, {
    key: "setOptionState",
    value: function setOptionState(state) {
      var _this$data = this.data,
          selected = _this$data.selected,
          disabled = _this$data.disabled,
          readonly = _this$data.readonly;

      if (disabled || readonly) {
        return;
      }

      this.select.trySetSelect(this.id, state);

      if (state === OptionState.SELECTED && !selected || state === OptionState.UNSELECTED && selected) {
        this.select.setSelect(this.id, state);
      }
    }
  }, {
    key: "updateSelected",
    value: function updateSelected(selected) {
      this.data.selected = selected;
      this.stateUpdated();
    }
  }, {
    key: "getOptionState",
    value: function getOptionState() {
      if (this.data.selected) {
        return OptionState.SELECTED;
      }

      return OptionState.UNSELECTED;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "getOptionIdPath",
    value: function getOptionIdPath() {
      var path = [this.id];

      if (!this.optionGroup) {
        return path;
      }

      return this.optionGroup.getOptionIdPath().concat(path);
    }
  }, {
    key: "isGroup",
    value: function isGroup() {
      return false;
    }
  }, {
    key: "stateUpdated",
    value: function stateUpdated() {
      this.emit('state-updated');
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.disposed) {
        return;
      }

      this.select.unregisterOption(this);

      if (this.optionGroup) {
        this.optionGroup.unregisterOption(this);
      }

      this.disposed = true;
    }
  }]);

  return Option;
}(Emitter);